import React from "react";
import { pure } from "recompose";

import Goal from "./Goal";

const FIGoals = pure(({ team }) => (
  <Goal
    name="Sufficient Capital?"
    checked={team.ending_cash && team.ending_cash >= 0 ? true : null}
  />
));

export default FIGoals;



// WEBPACK FOOTER //
// ./src/components/dashboard/FIGoals.js